import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  // private url = "/api/"; // Assuming proxy is configured
  private readonly url = environment.apiURL // Only For local testing
  private readonly MyxeniusURL = environment.myxenius // For Myxenius File
  constructor(private http: HttpClient) {}

  login(formData: FormData): Observable<any> {
    return this.http.post<any>(this.url+"Login", formData);
  }

  forgotPassword(formData: FormData): Observable<any> {
    return this.http.post<any>(this.url+"AdminForgotPassword", formData);
  }

  otpVerify(formData: FormData): Observable<any> {
    return this.http.post<any>(this.url+"AdminOTPVerify", formData);
  }

  resendVerify(formData: FormData): Observable<any> {
    return this.http.post<any>(this.url+"ResendOTP", formData);
  }

  resetPassword(formData: FormData): Observable<any> {
    return this.http.post<any>(this.url+"ResetPassword", formData);
  }
  changePassword(formData:FormData) : Observable<any>{
    return this.http.post<any>(this.url+'ChangePassword',formData)
  }
  resetToken(): Observable<any> {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('AuthToken', token || '');

    return this.http.post<any>(this.url + "RefreshToken", formData);
  }
  directLogin(token:string):Observable<any> {
    const payload:any = {
      d:token
    }
    const tokenAuth = btoa('bijleebuddy')
    const headers = new HttpHeaders({
    Authorization : `Bearer ${tokenAuth}`
  });
      const formData = new FormData();

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key]);
  });
    return this.http.post<any>(this.MyxeniusURL+'/NOC_api/validate_token',formData,{headers})
  }
}
